import type {SlotGameStore} from "@gamzix/slot_core";

class GameReelsetComponent extends SlotGame.src.component.ReelsetComponent {
    public TIME_STOP_DELAY = 400;
    public MIN_SPIN_DURATION = 300;

    async onStartBonusGame() {

    }

    async onFinishBonusGame() {
    }

    async onStartBonusGameCustom() {
        await super.onStartBonusGame();
    }

    async onFinishBonusGameCustom() {
        await super.onFinishBonusGame();
    }

    async onStartFreeSpinsGame() {
        await game.utils.delay(500);

        await super.onStartFreeSpinsGame();
    }

    async onFinishFreeSpinsGame() {
        await game.utils.delay(500);

        await super.onFinishFreeSpinsGame();
    }

    checkHoldPositions(): Boolean {
        return super.checkHoldPositions() && this.store.gameData.mode == "bonus";
    }

    getFSMHandlers():any {
        return {
            ...super.getFSMHandlers(),
            START: {
                ...super.getFSMHandlers()['START'],
                checkRestoreBonusGame: {
                    on: super.onStartBonusGame.bind(this)
                }
            }
        }
    }
}

// @ts-ignore
Game.src.component.ReelsetComponent = GameReelsetComponent